import breakpoints from '../theme/breakpoints'

export const mediaqueries = {
  xs: `(min-width: ${breakpoints.xs}rem)`,
  sm: `(min-width: ${breakpoints.sm}rem)`,
  md: `(min-width: ${breakpoints.md}rem)`,
  lg: `(min-width: ${breakpoints.lg}rem)`,
  xl: `(min-width: ${breakpoints.xl}rem)`,
  max: {
    xs: `(max-width: ${breakpoints.xs}rem)`,
    sm: `(max-width: ${breakpoints.sm}rem)`,
    md: `(max-width: ${breakpoints.md}rem)`,
    lg: `(max-width: ${breakpoints.lg}rem)`,
    xl: `(max-width: ${breakpoints.xl}rem)`,
  },
}
